common.View.create('canvas.blocks.custom.callToAction.Block', {

    onDOMLoad() {
        this.initMaxLength();
    },

    initMaxLength() {
        let isCanvasEditing = this.element.data('edit');

        if(!isCanvasEditing) {
            return;
        }

        let editor = this.element.find('.ctaText .canvas\\:\\:canvas-blocks-utils-text-Block').first();
        editor.attr('contenteditable', 'true');

        const lineHeight = parseInt(editor.css('line-height'));
        const maxLines = 2;
        const maxEditorHeight = lineHeight * maxLines;

        editor.on('input', function() {
            setTimeout(() => {
                if (editor.height() > maxEditorHeight) {
                    let content = editor.text();

                    while (editor.height() > maxEditorHeight && content.length > 0) {
                        content = content.slice(0, -1);
                        editor.text(content);
                    }

                    // Zet de cursor terug op het einde (internet ergens)
                    let range = document.createRange();
                    let sel = window.getSelection();
                    range.selectNodeContents(editor[0]);
                    range.collapse(false);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }, 1);
        });
    }

    // Dit werkt ook alleen is harder op characters en sommige letters zijn langer.

    // initMaxLength() {
    //     let editor = this.element.find('.myeditor .canvas\\:\\:canvas-blocks-utils-text-Block');
    //
    //     const maxCharacters = 70;
    //
    //     editor.on('input', function(event) {
    //         let currentTarget = $(event.currentTarget);
    //         let pText = currentTarget.find('p').first().text();
    //
    //         if (pText.length > maxCharacters) {
    //             let trimmedText = pText.substring(0, maxCharacters);
    //             currentTarget.find('p').first().text(trimmedText);
    //
    //             restoreCursorAfterTrim(currentTarget.find('p').first());
    //         }
    //     });
    //
    //     // idk op internet gevonden
    //     function restoreCursorAfterTrim(element) {
    //         let range = document.createRange();
    //         let sel = window.getSelection();
    //         // range.setStart(element[0], maxCharacters);
    //         // range.collapse(true);
    //         range.selectNodeContents(element[0]);
    //         range.collapse(false);
    //         sel.removeAllRanges();
    //         sel.addRange(range);
    //     }
    // }

});
